import { combineReducers, configureStore } from "@reduxjs/toolkit";
import { persistReducer, persistStore } from "redux-persist";
import storage from "redux-persist/lib/storage";
import authReducer from "./slices/authSlice";
import eventsReducer from "./slices/eventsSlice";
import ticketUploadsReducer from "./slices/ticketUploadsSlice";
import ticketsReducer from "./slices/ticketsSlice";
import tapLogsReducer from "./slices/tapLogsSlice";
import auditTrailReducer from "./slices/auditTrailSlice";
import sourceChannelsReducer from "./slices/sourceChannelsSlice";
import dashboardReducer from "./slices/dashboardSlice";

const rootReducer = combineReducers({
  auth: authReducer,
  events: eventsReducer,
  ticketUploads: ticketUploadsReducer,
  tickets: ticketsReducer,
  tapLogs: tapLogsReducer,
  auditTrail: auditTrailReducer,
  sourceChannels: sourceChannelsReducer,
  dashboard: dashboardReducer,
});

const persistConfig = {
  key: "mrt-speciallane",
  storage,
  whitelist: ["auth"],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export const persistor = persistStore(store);
